import { http } from './config'

export default {

  getAllVehicleTypes: () => {
    return http.get('vehicle_types')
  },

  getFilteredVehicleTypes: (params) => {
    return http.get('vehicle_types', {params})
  },

  getVehicleTypeById: (vehicleTypeId) => {
    return http.get('vehicle_types/' + vehicleTypeId)
  },

  createVehicleType: (vehicleTypesParams) => {
    return http.post('vehicle_types', {
      name: vehicleTypesParams.name,
      weight_capacity: vehicleTypesParams.weight_capacity,
      cubage_capacity: vehicleTypesParams.cubage_capacity,
      volume_capacity: vehicleTypesParams.volume_capacity
    }
  )},

  updateVehicleType: (vehicleTypesParams) => {
    return http.put('vehicle_types/' + vehicleTypesParams.vehicleTypeId, {
      name: vehicleTypesParams.name,
      weight_capacity: vehicleTypesParams.weight_capacity,
      cubage_capacity: vehicleTypesParams.cubage_capacity,
      volume_capacity: vehicleTypesParams.volume_capacity
    })
  },
  
  deleteVehicleType: vehicleTypeId => {
    return http.delete('vehicle_types/' + vehicleTypeId)
  }
}
